import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { CardTitle, Button, Form } from '@cordata/buffet';
import { useFormikContext } from 'formik';

import { usePatient } from '~/utils/patient';
import { Dropzone } from '~/components';

const initialValues = {
  file: undefined,
  fileUrl: undefined,
};

const Fields = () => {
  const { setFieldValue, values } = useFormikContext();
  useEffect(() => {
    if (values.file) {
      setFieldValue('link', values.file.base64);
    }
  }, [values.file]);

  return (
    <fieldset>
      <Dropzone
        setFile={f => setFieldValue('file', f)}
        acceptFileTypes="image/*"
      />

      {values.file && (
        <p className="mt-3">
          <CardTitle>Preview</CardTitle>

          <a target="_blank" rel="noreferrer" href={values.link}>
            <img src={values.link} alt="" className="mw-100 border rounded border-dark" />
          </a>
        </p>
    )}
    </fieldset>
  );
};

const ChangeProfilePicture = ({ isOpen, toggle }) => {
  const [,, actions] = usePatient();

  const handleSubmit = (v, b) =>
    actions.changeProfilePicture(v)
      .then(actions.refresh)
      .catch((e) =>
        b.setErrors({ server: e }));

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
    >
      <ModalHeader toggle={toggle}>Change Profile Picture</ModalHeader>

      <Form
        name="ChangeProfilePicture"

        initialValues={initialValues}

        onSubmit={handleSubmit}
      >
        {({
          dirty,
          isSubmitting,
        }) => (
          <>
            <ModalBody className="p-0">
              <Fields />
            </ModalBody>

            <ModalFooter>
              <Button
                type="cancel"
                outline
                onClick={toggle}
              >
                Cancel Change
              </Button>

              <Button
                type="submit"
                disabled={
                  !dirty ||
                  isSubmitting
                }
              >
                {isSubmitting ? 'Changing Picture ...' : 'Change Picture'}
              </Button>
            </ModalFooter>
          </>
        )}
      </Form>
    </Modal>
  );
};

ChangeProfilePicture.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ChangeProfilePicture;
